import React from 'react';
import { IParentComponent } from '../interfaces/IParentComponent';
import classNames from 'classnames';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

export const AlertBannerTW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames(
        'w-full rounded border-2 border-solid border-orange-400 bg-orange-100 p-4 text-center text-black',
        className
      )}
      data-test-id={mergeTests(rest['data-test-id'], 'alert-banner-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'alert-banner-tw')}
      {...rest}
    >
      <div className={'flex w-full flex-row items-center gap-4'}>
        <ExclamationTriangleIcon
          className={'h-6 w-6 grow-0 text-orange-400'}
          data-test-id={mergeTests(rest['data-test-id'], 'alert-banner-tw-exclamation-triangle')}
          data-test-class={mergeTests(rest['data-test-class'], 'alert-banner-tw-exclamation-triangle')}
        />
        <div>{children}</div>
      </div>
    </div>
  );
};
